import React, { Component, useState, useEffect } from "react";
import { Route, Redirect, useHistory } from "react-router-dom"
import axiosInstance from "../src/helpers/axiosInstance"
import axios from "axios";

export const ProtectedRoute = ({ component: Component, ...rest }) => {
    const [isAuth, setIsAuth] = useState('')
    const history = useHistory();

    useEffect(() => {
        //isAuthenticated(history);
        async function auth() {
            const request = await axios
            .get("/webapi/api/User/ping")
            .then(res => {
                return 'ok'
            })
            .catch(err => {
                return 'err';
            });
            setIsAuth(request);
            return request;
        }
        //auth();
    }, []);

    return (
        <Route
            {...rest}
            render={props => {
                //if (isAuth === 'err') {
                //    return <Redirect to={
                //            {
                //                pathname: "/auth/login",
                //                state: {
                //                    from: props.location
                //                }
                //            }
                //        } />
                //} else {
                    return <Component {...props} />;
                //}
            }}
        />
    );
};